export var Color = {
  TextPrimary: 'txt-primary',
  TextPrimaryInvert: 'txt-primary-invert',
  TextSecondary: 'txt-secondary',
  TextSecondaryInvert: 'txt-secondary-invert',
  TextPlaceholder: 'txt-placeholder',
  AccentPrimary: 'accent-primary',
  AccentPrimaryHover: 'accent-primary-hover',
  AccentPrimaryActive: 'accent-primary-active',
  AccentPrimaryDisabled: 'accent-primary-disabled',
  BackgroundPrimary: 'bg-primary',
  BackgroundPrimaryHover: 'bg-primary-hover',
  BackgroundPrimaryActive: 'bg-primary-active',
  BackgroundPrimary_0_5_Opacity: 'bg-primary-0-5-opacity',
  BackgroundSecondary: 'bg-secondary',
  IconsPrimary: 'icons-primary',
  IconsPrimaryOpacity_0_6: 'icons-primary-opacity-0-6',
  IconsSecondary: 'icons-secondary',
  ButtonPrimaryText: 'btn-primary-text',
  ButtonDisabledText: 'btn-disabled-text',
  LinkPrimary: 'link-primary',
  LinkHover: 'link-hover',
  LinkActive: 'link-active',
  BordersPrimary: 'borders-primary',
  BordersSecondary: 'borders-secondary',
  BordersStrong: 'borders-strong',
  BordersInvert: 'borders-invert',
  BorderActiveBottom: 'border-active-bottom',
  ActiveSecondary: 'active-secondary',
  ActiveSecondaryHover: 'active-secondary-hover',
  ActiveSecondaryActive: 'active-secondary-active',
  Tag: 'tag',
  Error: 'error',
  Success: 'success',
  Warning: 'warning',
  Info: 'info',
  LightShadow: 'light-shadow'
};